import React, { Component } from "react"
import { Link, graphql } from "gatsby"
import AOS from 'aos'
import Layout from "../layouts"
import { TimelineMax, TweenLite, Linear } from "gsap/all";
import ScrollMagic from 'scrollmagic';
import Lottie from 'react-lottie';
import LottieModule from '../components/LottieModule';
import $ from 'jquery';
import "../../node_modules/scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap";
import { Helmet } from "react-helmet"

var gearData = {"v":"5.5.8","fr":30,"ip":0,"op":45,"w":600,"h":600,"nm":"Gear_Icon","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Lg Gear Center 1 Outlines","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[238.111,219.704,0],"ix":2},"a":{"a":0,"k":[75.577,75.578,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-7.772,-25.022],[25.022,-7.772],[7.772,25.021],[-25.022,7.772]],"o":[[7.771,25.021],[-25.022,7.772],[-7.772,-25.022],[25.022,-7.772]],"v":[[45.307,-14.072],[14.072,45.306],[-45.305,14.073],[-14.072,-45.306]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[0]},{"t":10,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"st","c":{"a":0,"k":[0.043000000598,0.109999997008,0.243000000598,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":9,"ix":5},"lc":2,"lj":1,"ml":10,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[75.577,75.578],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":180,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"Lg Gear Center 2 Outlines","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[238.111,219.704,0],"ix":2},"a":{"a":0,"k":[99.457,99.456,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-11.268,-36.278],[36.279,-11.268],[11.268,36.279],[-36.279,11.268]],"o":[[11.269,36.279],[-36.278,11.268],[-11.269,-36.278],[36.278,-11.268]],"v":[[65.688,-20.403],[20.403,65.688],[-65.688,20.403],[-20.403,-65.688]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[0]},{"t":10,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"st","c":{"a":0,"k":[0.043000000598,0.109999997008,0.243000000598,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":9,"ix":5},"lc":2,"lj":1,"ml":10,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[99.457,99.456],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":180,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"Lg Gear 3 Outlines","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[238.111,219.704,0],"ix":2},"a":{"a":0,"k":[151.821,151.82,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-18.936,-60.964],[60.964,-18.936],[18.936,60.964],[-60.964,18.936]],"o":[[18.936,60.964],[-60.963,18.935],[-18.936,-60.964],[60.964,-18.936]],"v":[[110.385,-34.285],[34.286,110.386],[-110.385,34.287],[-34.286,-110.384]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[0]},{"t":10,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"st","c":{"a":0,"k":[0.043000000598,0.109999997008,0.243000000598,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":9,"ix":5},"lc":2,"lj":1,"ml":10,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[151.821,151.82],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":180,"st":0,"bm":0},{"ddd":0,"ind":4,"ty":4,"nm":"Lg Gear Outlines","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[238.202,219.998,0],"ix":2},"a":{"a":0,"k":[194.887,194.888,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[16.429,-1.037],[0,0],[2.607,4.258],[0,0],[0,0],[0,0],[0,0],[0,0],[14.781,-7.245],[0,0],[4.081,2.954],[0,0],[0,0],[0,0],[0,0],[0,0],[10.883,-12.35],[0,0],[4.931,1.181],[0,0],[0,0],[0,0],[0,0],[0,0],[5.329,-15.574],[0,0],[5.043,-0.818],[0,0],[0,0],[0,0],[0,0],[0,0],[-1.037,-16.428],[0,0],[4.28,-2.639],[0,0],[0,0],[0,0],[0,0],[0,0],[-7.245,-14.781],[0,0],[2.949,-4.1],[0,0],[0,0],[0,0],[0,0],[0,0],[-12.35,-10.884],[0,0],[1.163,-4.922],[0,0],[0,0],[0,0],[0,0],[0,0],[-15.575,-5.33],[0,0],[-0.823,-5.007],[0,0],[0,0],[0,0],[0,0],[0,0],[-16.428,1.037],[0,0],[-2.617,-4.234],[0,0],[0,0],[0,0],[0,0],[0,0],[-14.781,7.245],[0,0],[-4.05,-2.914],[0,0],[0,0],[0,0],[0,0],[0,0],[-10.883,12.35],[0,0],[-4.861,-1.156],[0,0],[0,0],[0,0],[0,0],[0,0],[-5.329,15.574],[0,0],[-4.957,0.802],[0,0],[0,0],[0,0],[0,0],[0,0],[1.037,16.427],[0,0],[-4.213,2.586],[0,0],[0,0],[0,0],[0,0],[0,0],[7.245,14.782],[0,0],[-2.918,4.031],[0,0],[0,0],[0,0],[0,0],[0,0],[12.35,10.883],[0,0],[-1.171,4.87],[0,0],[0,0],[0,0],[0,0],[0,0],[15.574,5.329],[0,0],[0.798,4.994],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[-2.172,-4.586],[0,0],[9.816,-13.214],[0,0],[0,0],[0,0],[0,0],[0,0],[-3.758,-3.387],[0,0],[4.011,-15.965],[0,0],[0,0],[0,0],[0,0],[0,0],[-4.757,-1.694],[0,0],[-2.405,-16.284],[0,0],[0,0],[0,0],[0,0],[0,0],[-5.019,0.264],[0,0],[-8.452,-14.125],[0,0],[0,0],[0,0],[0,0],[0,0],[-4.614,2.197],[0,0],[-13.214,-9.815],[0,0],[0,0],[0,0],[0,0],[0,0],[-3.385,3.776],[0,0],[-15.965,-4.011],[0,0],[0,0],[0,0],[0,0],[0,0],[-1.675,4.75],[0,0],[-16.285,2.404],[0,0],[0,0],[0,0],[0,0],[0,0],[0.278,4.984],[0,0],[-14.125,8.452],[0,0],[0,0],[0,0],[0,0],[0,0],[2.185,4.562],[0,0],[-9.815,13.215],[0,0],[0,0],[0,0],[0,0],[0,0],[3.735,3.339],[0,0],[-4.01,15.965],[0,0],[0,0],[0,0],[0,0],[0,0],[4.693,1.655],[0,0],[2.404,16.284],[0,0],[0,0],[0,0],[0,0],[0,0],[4.935,-0.27],[0,0],[8.453,14.125],[0,0],[0,0],[0,0],[0,0],[0,0],[4.535,-2.16],[0,0],[13.214,9.815],[0,0],[0,0],[0,0],[0,0],[0,0],[3.342,-3.717],[0,0],[15.965,4.01],[0,0],[0,0],[0,0],[0,0],[0,0],[1.673,-4.701],[0,0],[16.284,-2.404],[0,0],[0,0],[0,0],[0,0],[0,0],[-0.257,-4.97],[0,0],[14.125,-8.453],[0,0],[0,0],[0,0]],"v":[[160.34,-61.45],[134.507,-62.94],[127.577,-60.934],[120.416,-74.215],[125.82,-78.802],[138.636,-101.28],[138.499,-102.782],[126.07,-117.721],[124.619,-118.132],[100.183,-109.622],[94.643,-105.193],[82.891,-114.728],[86.087,-120.953],[89.325,-146.624],[88.623,-147.959],[71.423,-157.006],[69.926,-156.829],[50.607,-139.616],[47.231,-133.491],[32.683,-137.786],[33.248,-144.689],[26.415,-169.647],[25.256,-170.611],[5.903,-172.387],[4.588,-171.65],[-6.675,-148.355],[-7.441,-141.475],[-22.543,-139.835],[-24.654,-146.398],[-40.516,-166.842],[-41.956,-167.288],[-60.516,-161.523],[-61.449,-160.34],[-62.939,-134.507],[-61.008,-127.836],[-74.366,-120.594],[-78.802,-125.821],[-101.28,-138.637],[-102.781,-138.499],[-117.722,-126.07],[-118.131,-124.618],[-109.622,-100.183],[-105.264,-94.733],[-114.775,-82.915],[-120.952,-86.087],[-146.624,-89.325],[-147.958,-88.622],[-157.006,-71.424],[-156.828,-69.926],[-139.616,-50.605],[-133.434,-47.2],[-137.672,-32.674],[-144.689,-33.247],[-169.646,-26.415],[-170.61,-25.256],[-172.387,-5.902],[-171.65,-4.588],[-148.354,6.675],[-141.242,7.468],[-139.579,22.461],[-146.399,24.654],[-166.841,40.516],[-167.288,41.956],[-161.524,60.516],[-160.34,61.449],[-134.507,62.939],[-127.502,60.911],[-120.305,74.12],[-125.82,78.801],[-138.636,101.28],[-138.498,102.781],[-126.07,117.722],[-124.618,118.131],[-100.182,109.622],[-94.4,104.999],[-82.716,114.386],[-86.087,120.952],[-89.325,146.624],[-88.623,147.959],[-71.423,157.006],[-69.926,156.828],[-50.606,139.616],[-46.988,133.051],[-32.639,137.249],[-33.247,144.689],[-26.415,169.646],[-25.256,170.61],[-5.903,172.387],[-4.587,171.65],[6.675,148.354],[7.509,140.869],[22.355,139.249],[24.654,146.399],[40.517,166.842],[41.957,167.289],[60.516,161.524],[61.449,160.34],[62.94,134.508],[60.837,127.243],[73.972,120.13],[78.802,125.82],[101.28,138.636],[102.781,138.498],[117.723,126.07],[118.132,124.619],[109.622,100.182],[104.928,94.31],[114.34,82.692],[120.953,86.087],[146.624,89.325],[147.959,88.623],[157.006,71.423],[156.829,69.925],[139.616,50.606],[133.11,47.021],[137.363,32.648],[144.69,33.247],[169.647,26.415],[170.611,25.256],[172.387,5.903],[171.65,4.587],[148.355,-6.674],[141.102,-7.483],[139.505,-22.437],[146.399,-24.654],[166.841,-40.517],[167.289,-41.957],[161.524,-60.516]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[0]},{"t":25,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"st","c":{"a":0,"k":[0.043000000598,0.109999997008,0.243000000598,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":9,"ix":5},"lc":2,"lj":1,"ml":10,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[194.887,194.888],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":180,"st":0,"bm":0},{"ddd":0,"ind":5,"ty":4,"nm":"Sm Gear Center Outlines","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[428.31,446.438,0],"ix":2},"a":{"a":0,"k":[83.415,83.416,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-9.287,-28.514],[28.514,-9.287],[9.287,28.514],[-28.514,9.288]],"o":[[9.287,28.514],[-28.514,9.287],[-9.287,-28.514],[28.513,-9.287]],"v":[[51.629,-16.816],[16.815,51.628],[-51.629,16.816],[-16.815,-51.628]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":18,"s":[0]},{"t":28,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"st","c":{"a":0,"k":[0.043000000598,0.109999997008,0.243000000598,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":9,"ix":5},"lc":2,"lj":1,"ml":10,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[83.415,83.416],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":180,"st":0,"bm":0},{"ddd":0,"ind":6,"ty":4,"nm":"Sm Gear Outlines","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[428.155,446.359,0],"ix":2},"a":{"a":0,"k":[128.531,128.529,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[16.278,-1.252],[0,0],[5.528,4.845],[0,0],[0,0],[0,0],[0,0],[0,0],[10.624,-12.395],[0,0],[7.48,-0.483],[0,0],[0,0],[0,0],[0,0],[0,0],[-1.252,-16.277],[0,0],[4.817,-5.469],[0,0],[0,0],[0,0],[0,0],[0,0],[-12.396,-10.625],[0,0],[-0.457,-7.453],[0,0],[0,0],[0,0],[0,0],[0,0],[-16.278,1.252],[0,0],[-5.477,-4.845],[0,0],[0,0],[0,0],[0,0],[0,0],[-10.625,12.394],[0,0],[-7.519,0.461],[0,0],[0,0],[0,0],[0,0],[0,0],[1.252,16.277],[0,0],[-4.874,5.536],[0,0],[0,0],[0,0],[0,0],[0,0],[12.395,10.625],[0,0],[0.488,7.545],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[-4.069,-6.338],[0,0],[3.761,-15.886],[0,0],[0,0],[0,0],[0,0],[0,0],[-7.145,-1.556],[0,0],[-8.574,-13.893],[0,0],[0,0],[0,0],[0,0],[0,0],[-6.283,4.034],[0,0],[-15.887,-3.76],[0,0],[0,0],[0,0],[0,0],[0,0],[-1.568,7.116],[0,0],[-13.893,8.575],[0,0],[0,0],[0,0],[0,0],[0,0],[4.029,6.319],[0,0],[-3.76,15.887],[0,0],[0,0],[0,0],[0,0],[0,0],[7.174,1.597],[0,0],[8.574,13.892],[0,0],[0,0],[0,0],[0,0],[0,0],[6.375,-4.063],[0,0],[15.887,3.759],[0,0],[0,0],[0,0],[0,0],[0,0],[1.587,-7.202],[0,0],[13.892,-8.576],[0,0],[0,0],[0,0]],"v":[[98.874,-43.675],[73.236,-44.801],[67.308,-43.072],[52.835,-59.892],[55.546,-65.439],[58.41,-90.942],[57.695,-92.255],[40.515,-100.993],[39.033,-100.797],[20.108,-83.465],[17.076,-77.939],[-4.943,-79.579],[-6.994,-85.55],[-23.003,-105.606],[-24.437,-106.029],[-42.764,-100.062],[-43.673,-98.874],[-44.799,-73.237],[-43.002,-67.07],[-59.695,-52.741],[-65.438,-55.548],[-90.94,-58.41],[-92.255,-57.696],[-100.993,-40.515],[-100.796,-39.032],[-83.463,-20.108],[-77.821,-17.012],[-79.518,4.922],[-85.549,6.993],[-105.606,23.003],[-106.031,24.436],[-100.061,42.763],[-98.874,43.674],[-73.235,44.8],[-67.13,43.02],[-52.798,59.814],[-55.548,65.437],[-58.41,90.94],[-57.694,92.254],[-40.514,100.992],[-39.032,100.796],[-20.107,83.464],[-17.117,78.013],[5.004,79.752],[6.995,85.549],[23.003,105.605],[24.437,106.029],[42.765,100.06],[43.674,98.873],[44.8,73.235],[43.089,67.368],[60.01,52.893],[65.438,55.547],[90.94,58.409],[92.255,57.694],[100.992,40.514],[100.796,39.032],[83.464,20.106],[78.13,17.18],[79.812,-5.025],[85.549,-6.994],[105.606,-23.004],[106.031,-24.438],[100.06,-42.765]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":26,"s":[0]},{"t":44,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"st","c":{"a":0,"k":[0.043000000598,0.109999997008,0.243000000598,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":9,"ix":5},"lc":2,"lj":1,"ml":10,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[128.531,128.53],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":180,"st":0,"bm":0}],"markers":[]}

function myFunction(){
  var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
  var height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
  var scrolled = (winScroll / height) * 100;
  document.getElementById("progress-bar").style.width = scrolled + "%";
}

class Services extends Component {

  constructor(props) {
    super(props);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.handleGearIn = this.handleGearIn.bind(this);
    this.getScrollPoint = this.getScrollPoint.bind(this);
    this.getScrollPointKeyPress = this.getScrollPointKeyPress.bind(this);
  }

  componentDidMount() {
    AOS.init();

    let pageData = [];

    window.onscroll = () => {
      myFunction();
      this.props.data.allWordpressWpServices.edges.map((wpDataObject, i) => {
        this.handleKeyPress(i);
      })
      this.handleGearIn();
    };

    if (window.innerWidth > 768){
      var checkExist = setInterval(() => {
        if ($('#pinContainer').length) {
          var percent = 0;
          var percentString = '';
          let count = 0;

          this.props.data.allWordpressWpServices.edges.map(({ node }) => {
            percent += window.innerHeight * 1.8;
            count++
            percentString = (percent * this.props.data.allWordpressWpServices.edges.length) / this.props.data.allWordpressWpServices.edges.length;
          })

          var controller = new ScrollMagic.Controller({globalSceneOptions: {triggerHook: "onLeave", duration: "100%"}});
          var navigation = new ScrollMagic.Controller({globalSceneOptions: {triggerHook: "onLeave", duration: `${percentString}`}});

          var tween = new TimelineMax();
          let panel = '';
          let panelTest = '';

          var size = controller.info("size");

          this.props.data.allWordpressWpServices.edges.map(({ node }) => {

            let id = "#sec" + node.slug;
            let id2 = "#high" + node.slug;
            new ScrollMagic.Scene({triggerElement: `${id}`})
              .setClassToggle(`${id2}`, "active")
              .setPin(`${id}`)
              .addTo(controller)
              .on('enter', function(e){
                panelTest = $(e.target.triggerElement()).prop('id');
                panel = $(e.target.triggerElement()).find('.inner')
                $(panel).addClass('active');
              })
              .on('leave', function(e){
                panelTest = $(e.target.triggerElement()).prop('id');
                panel = $(e.target.triggerElement()).find('.inner')
                $(panel).removeClass('active');
              });
          })

          new ScrollMagic.Scene({triggerElement: '#pinContainer'})
              .setClassToggle('.vertical-navigation-dots', "active")
              .addTo(navigation)
          
        }
        clearInterval(checkExist);
      }, 100);
    }
    window.onload = () => {
      AOS.refresh();
    }   
  }

  getScrollPoint(node){

    var dots = document.getElementsByClassName('dot');

    for (let i = 0; i < dots.length; i++) {
      dots[i].classList.remove('active');
    }
    
    let id = "sec" + node.node.slug;
    let id2 = "high" + node.node.slug;
    console.log(id)
    var anchor = document.getElementById(`${id}`);
    var dot = document.getElementById(`${id2}`);
    if (anchor !== null){

      console.log(anchor.getBoundingClientRect().top + window.scrollY)
      window.scrollTo(window.pageYOffset, anchor.getBoundingClientRect().top + window.scrollY);
      anchor.getElementsByClassName("inner")[0].classList.add('active');
      dot.classList.add('active')
    } else {
      console.log(anchor)
    }
  }

  getScrollPointKeyPress(e, node){
    var charCode = e.charCode || e.keyCode;
    if(charCode == 13) {

      var dots = document.getElementsByClassName('dot');

      for (let i = 0; i < dots.length; i++) {
        dots[i].classList.remove('active');
      }
      
      let id = "sec" + node.node.slug;
      let id2 = "high" + node.node.slug;
      console.log(id)
      var anchor = document.getElementById(`${id}`);
      var dot = document.getElementById(`${id2}`);
      if (anchor !== null){

        console.log(anchor.getBoundingClientRect().top + window.scrollY)
        window.scrollTo(window.pageYOffset, anchor.getBoundingClientRect().top + window.scrollY);
        anchor.getElementsByClassName("inner")[0].classList.add('active');
        dot.classList.add('active')
      } else {
        console.log(anchor)
      }
    }
  }

  fadeRightvsUp(){
    if (typeof window !== 'undefined' && window.innerWidth > 768){
      return "fade-right"
    }else{
      return "fade-up"
    }
  }

  handleKeyPress(i) {

  }

  handleGearIn() {
    var elementToBaseScrollOffOf = document.getElementById("gearWrapper");
    if(elementToBaseScrollOffOf !== null){
      var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
      if(elementToBaseScrollOffOf.getBoundingClientRect().top - window.innerHeight + elementToBaseScrollOffOf.getBoundingClientRect().height/2 < 0){
       this[`gearDataRef`].play()
      }
    }
  }

  openAccordion(e, i){

    let activeElement = document.getElementById(`serviceDropDown_${i}`);
    let activeService = document.getElementById(`service_${i}`);

    if (!activeElement.classList.contains('active')){
      let height = activeElement.scrollHeight;
      activeElement.classList.add("active");
      activeElement.style.maxHeight = height + 'px';
      activeService.classList.add("active");
    
    }else{
      activeElement.classList.remove("active");
      activeElement.style.maxHeight = '0px';
      activeService.classList.remove("active");
    }
  }

  getAnchorStaggered300(){
     if (typeof window !== 'undefined' && window.innerWidth > 768){
      return "300"
    }else{
      return "300"
    }
  }

  getAnchorStaggered600(){
     if (typeof window !== 'undefined' && window.innerWidth > 768){
      return "600"
    }else{
      return "300"
    }
  }
  
  getAnchorStaggered900(){
     if (typeof window !== 'undefined' && window.innerWidth > 768){
      return "900"
    }else{
      return "300"
    }
  }

  getAnchorStaggered900to600(){
     if (typeof window !== 'undefined' && window.innerWidth > 768){
      return "900"
    }else{
      return "600"
    }
  }

  getAnchorStaggered300to1600(){
    if (typeof window !== 'undefined' && window.innerWidth > 768){
      return "300"
    }else{
      return "1200"
    }
  }

  getAnchorStaggered1200(){
     if (typeof window !== 'undefined' && window.innerWidth > 768){
      return "1200"
    }else{
      return "300"
    }
  }

  getAnchorStaggered1200Line(){
     if (typeof window !== 'undefined' && window.innerWidth > 768){
      return "1200"
    }else{
      return "900"
    }
  }


  getAnchorStaggered1600(){
     if (typeof window !== 'undefined' && window.innerWidth > 768){
      return "1600"
    }else{
      return "300"
    }
  }

  getAnchorStaggered1600to600(){
     if (typeof window !== 'undefined' && window.innerWidth > 768){
      return "1600"
    }else{
      return "600"
    }
  }

  getAnchorStaggeredRowOne(){
    if (typeof window !== 'undefined' && window.innerWidth > 768){
      return ".staggered_row_one"
    }else{
      return ""
    }
  }

  getAnchorStaggeredRowTwo(){
    if (typeof window !== 'undefined' && window.innerWidth > 768){
      return ".staggered_row_two"
    }else{
      return ""
    }
  }

  render() {

    const data = this.props.data

    const metaData = this.props.data.allWordpressAcfOptions.group[0].edges[0].node.options.meta_data_by_page.services

    let totalLoop = 0;

    let acfColor = '#F3A738'

    if (typeof window === 'undefined'){
      return (
        <Layout>
        <Helmet script={[{
            type: 'application/ld+json',
            innerHTML: JSON.stringify({
              "@context": "http://schema.org",
              "@type": "WebPage",
              "url": "https://excelinstore.com/",
              "name": "Excel | Moving Retail Forward",
              "author": {
                  "@type": "Organization",
                  "name": "Excel",
                  "url": "https://excelinstore.com/",
                  "address": {
                      "@type": "PostalAddress",
                      "streetAddress": "1021 International Drive",
                      "addressLocality": "Fergus Falls",
                      "addressRegion": "MN",
                      "postalCode": "56537",
                      "addressCountry": "USA"
                  },
                  "contactPoint": {
                      "@type": "ContactPoint",
                      "contactType": "customer support",
                      "telephone": "+1-218-998-3800",
                      "email": "contact@excelinstore.com"
                  }
              },
              "description": "We guide clients through the creation of in-store visual merchandising displays and fixtures.",
              "publisher": {
                  "@type": "Organization",
                  "name": "Excel",
                  "url": "https://excelinstore.com/",
                  "address": {
                      "@type": "PostalAddress",
                      "streetAddress": "1021 International Drive",
                      "addressLocality": "Fergus Falls",
                      "addressRegion": "MN",
                      "postalCode": "56537",
                      "addressCountry": "USA"
                  }
              }
            })
          }]}>
          <html lang="en" />
          <meta charSet="utf-8" />
          <title>Excel | Services</title>
          <meta name="description" content={metaData.description} />
          <meta property="og:title" content={"Excel | Services"}  />
          <meta property="og:type" content="WebSite" />
          <meta property="og:url" content="https://excelinstore.com/" />
          <meta property="og:image" content={metaData.image_data.url} />
          <meta property="og:image:type" content="image/jpeg" />
          <meta property="og:description" content={metaData.description} />
          <meta property="og:site_name" content="Excel" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={"Excel | Services" } />
          <meta name="twitter:description" content={metaData.description} />
          <meta name="twitter:image" content={metaData.image_data.url} />
          
        </Helmet>
      </Layout>
    )
  }else{
    var called = false
    window.addEventListener('mousedown', function() {
      if (called === false){
          let elem = document.getElementById('excel-global-header-inner')
          elem.classList.add('using-mouse');
          called = true
      }
    });

    return(
      <Layout>
        <Helmet script={[{
            type: 'application/ld+json',
            innerHTML: JSON.stringify({
              "@context": "http://schema.org",
              "@type": "WebPage",
              "url": "https://excelinstore.com/",
              "name": "Excel | Moving Retail Forward",
              "author": {
                  "@type": "Organization",
                  "name": "Excel",
                  "url": "https://excelinstore.com/",
                  "address": {
                      "@type": "PostalAddress",
                      "streetAddress": "1021 International Drive",
                      "addressLocality": "Fergus Falls",
                      "addressRegion": "MN",
                      "postalCode": "56537",
                      "addressCountry": "USA"
                  },
                  "contactPoint": {
                      "@type": "ContactPoint",
                      "contactType": "customer support",
                      "telephone": "+1-218-998-3800",
                      "email": "contact@excelinstore.com"
                  }
              },
              "description": "We guide clients through the creation of in-store visual merchandising displays and fixtures.",
              "publisher": {
                  "@type": "Organization",
                  "name": "Excel",
                  "url": "https://excelinstore.com/",
                  "address": {
                      "@type": "PostalAddress",
                      "streetAddress": "1021 International Drive",
                      "addressLocality": "Fergus Falls",
                      "addressRegion": "MN",
                      "postalCode": "56537",
                      "addressCountry": "USA"
                  }
              }
            })
          }]}>
          <html lang="en" />
          <meta charSet="utf-8" />
          <title>Excel | Services</title>
          <meta name="description" content={metaData.description} />
          <meta property="og:title" content={"Excel | Services"}  />
          <meta property="og:type" content="WebSite" />
          <meta property="og:url" content="https://excelinstore.com/" />
          <meta property="og:image" content={metaData.image_data.url} />
          <meta property="og:image:type" content="image/jpeg" />
          <meta property="og:description" content={metaData.description} />
          <meta property="og:site_name" content="Excel" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={"Excel | Services" } />
          <meta name="twitter:description" content={metaData.description} />
          <meta name="twitter:image" content={metaData.image_data.url} />
          
        </Helmet>
          <div className="progress"><div id="progress-bar" style={{backgroundColor: acfColor}}></div></div>
          <div className="services--wrapper">
            <div className="staggered_grid services-page cf">
              <div className="staggered_row_one cf">
                <div className="image">
                  <img src={data.allWordpressPage.edges[0].node.acf.services.services_intro.staggered_row_one.image_left.url} alt={data.allWordpressPage.edges[0].node.acf.services.services_intro.staggered_row_one.image_left.alt} data-aos-delay={this.getAnchorStaggered300to1600()} data-aos="fade-up" data-aos-anchor={this.getAnchorStaggeredRowOne()}/>
                  <div className="" data-aos="fade-up" data-aos-delay={this.getAnchorStaggered1600()} data-aos-anchor={this.getAnchorStaggeredRowOne()}>
                    <div className="icon">
                     <div className="lottie-element" id="gearWrapper">
                      <div className="inner">
                        <Lottie
                          ref={instance => (this[`gearDataRef`] = instance)}
                          options={{
                            loop: false,
                            autoplay: false,
                            animationData: gearData,
                            rendererSettings: {
                              preserveAspectRatio: 'xMidYMid slice'
                            }
                          }}
                        />
                        </div>
                    </div>
                    </div>
                  </div>
                </div>
                <div className="column-right">
                  <div className="title" data-aos="fade-up" data-aos-delay={this.getAnchorStaggered600()} data-aos-anchor={this.getAnchorStaggeredRowOne()}>Our Services</div>
                  <div className="header" dangerouslySetInnerHTML={{__html: data.allWordpressPage.edges[0].node.acf.services.services_intro.staggered_row_one.header}} data-aos="fade-up" data-aos-delay={this.getAnchorStaggered900to600()} data-aos-anchor={this.getAnchorStaggeredRowOne()}/>
                  <div className="flag b" data-aos="draw-line" data-aos-delay={this.getAnchorStaggered1200Line()} data-aos-anchor={this.getAnchorStaggeredRowOne()}>
                    <svg width="125px" height="10px" viewBox="0 0 125 10">
                      <g id="Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                        <g id="About---Desktop" transform="translate(-140.000000, -1460.000000)" fill="#FFFFFF">
                          <g id="Group" transform="translate(140.000000, 1460.000000)">
                            <polygon id="Rectangle-Copy-6" points="0 0 120.192308 0 125 5 120.192308 10 0 10 4.20673077 5"></polygon>
                          </g>
                        </g>
                      </g>
                    </svg>
                    <div className="NO-line"></div>
                  </div>
                  <div className="body" dangerouslySetInnerHTML={{__html: data.allWordpressPage.edges[0].node.acf.services.services_intro.staggered_row_one.body}} data-aos="fade-up" data-aos-delay={this.getAnchorStaggered1200()} data-aos-anchor={this.getAnchorStaggeredRowOne()} />
                  <div className="image--full" data-aos="fade-up" data-aos-delay={this.getAnchorStaggered1600()} data-aos-anchor={this.getAnchorStaggeredRowOne()}>
                    <img src={data.allWordpressPage.edges[0].node.acf.services.services_intro.staggered_row_two.image.url} alt={data.allWordpressPage.edges[0].node.acf.services.services_intro.staggered_row_two.image.alt} />
                  </div>
                </div>
              </div>
              <div className={data.allWordpressPage.edges[0].node.acf.services.services_intro.staggered_row_two.body ? 'show staggered_row_two cf' : 'hide staggered_row_two cf'}>
                {data.allWordpressPage.edges[0].node.acf.services.services_intro.staggered_row_two.body !== "" &&
                  <div className="body" dangerouslySetInnerHTML={{__html: data.allWordpressPage.edges[0].node.acf.services.services_intro.staggered_row_two.body}} data-aos="fade-up" data-aos-delay="300" data-aos-anchor={this.getAnchorStaggeredRowTwo()}>
                  </div>
                }
              </div>
              <div className="image--full mobile-only" data-aos="fade-up" data-aos-delay={this.getAnchorStaggered1600to600()} data-aos-anchor={this.getAnchorStaggeredRowOne()}>
                  <img src={data.allWordpressPage.edges[0].node.acf.services.services_intro.staggered_row_two.image.url} alt={data.allWordpressPage.edges[0].node.acf.services.services_intro.staggered_row_two.image.alt} />
                </div>
            </div>
            <div className="vertical-navigation-dots">
              {data.allWordpressWpServices.edges.map((node, i) => (
                <div tabIndex="0" className="dot-wrapper" key={node.node.slug} id={node.node.slug} onClick={() => this.getScrollPoint(node)} onKeyPress={(e) => this.getScrollPointKeyPress(e, node)}>
                  <div id={"high" + node.node.slug} className="dot"></div>
                </div>
              ))}
            </div>
            { typeof window !== 'undefined' && 
              window.innerWidth <= 768 &&
              data.allWordpressWpServices.edges.length > 0 &&

              <div className="services-accordion">
                <div className="content-wrapper-long">
                  { data.allWordpressWpServices.edges.map((node, index) => {
                    totalLoop++
                    var obj = JSON.parse(node.node.acf.service.preview_icon)
                    return (
                      <div className="accordion-wrapper" key={"service_" + index } data-aos="fade-up">
                        <div className="service-info-ribbon cf" id={"service_" + index } onClick={(e) => this.openAccordion(e, index)}>
                          <div className="service__name">
                            0{totalLoop}
                            <br />
                            {node.node.title}
                          </div>
                          <div className="arrow-services">
                            <span className="minus"></span>
                            <span className="plus"></span>
                          </div>
                        </div>
                        <div className="additional-info cf" id={"serviceDropDown_" + index } style={{'maxHeight':'0px'}}>
                          <div className="svg--container">
                            <div className="lottie-element" id={"iconAnimation" + index}>
                              <LottieModule data={obj} frameReset={node.node.acf.service.reset_point} loop={false} autoplay={false} loop={false}/>
                            </div>
                          </div>
                          { node.node.acf.service.detail_copy_one.length > 0 &&
                            <div className="description--short" dangerouslySetInnerHTML={{__html: node.node.acf.service.detail_copy_one}} />
                          }
                          { node.node.acf.service.detail_copy_two.length > 0 &&
                            <div className="description--long" dangerouslySetInnerHTML={{__html: node.node.acf.service.detail_copy_two}} />
                          }
                          
                        </div>
                      
                      </div>
                      )
                    })
                  }
                </div>
              </div>
            }
            { typeof window !== 'undefined' && 
              window.innerWidth > 768 &&
              data.allWordpressWpServices.edges.length > 0 &&
              <div id="pinContainer">
              {data.allWordpressWpServices.edges.map((node, index) => {
                totalLoop++
                var obj = JSON.parse(node.node.acf.service.preview_icon)
                return (
                  <section className={"panel " + node.node.slug} key={node.node.slug} id={"sec" + node.node.slug}>
                    <div className="inner">
                      <div className="left-column">
                        <div className="left-column--inner">
                          <span className="title">Our Process</span>
                          <div className="step-container">
                            <div className="step">0{totalLoop}</div>
                            <div className="step__name">{node.node.title}</div>
                          </div>
                          {node.node.acf.service.detail_copy_one.length > 0 &&
                            <div className="description--short" dangerouslySetInnerHTML={{__html: node.node.acf.service.detail_copy_one}} />
                          }
                          {node.node.acf.service.detail_copy_two.length > 0 &&
                            <div className="description--long" dangerouslySetInnerHTML={{__html: node.node.acf.service.detail_copy_two}} />
                          }
                        </div>
                      </div>
                      <div className="right-column">
                        <div className="left-column--inner">
                          <div className="svg--container">
                            <div className="lottie-element" id={"iconAnimation" + index}>
                              <LottieModule data={obj} frameReset={node.node.acf.service.reset_point} loop={false} autoplay={false} loop={false}/>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                  )
                })}
              </div>
            }
          </div>
        </Layout>
      )
  }
  }
}

export default Services

// Set here the ID of the home page.
export const pageQuery = graphql`
  query {
    allWordpressAcfOptions {
      group(field: id) {
        edges {
          node {
            options {
              meta_data_by_page {
                services {
                  description
                  image_data {
                    alt
                    url
                  }
                }
              }
            }
          }
        }
      }
    }
    allWordpressPage(filter: {template: {eq: "services.php"}}) {
      edges {
        node {
          id
          acf {
            services {
              services_intro {
                staggered_row_one {
                  animating_svg
                  body
                  header
                  image_left {
                    alt
                    url
                  }
                }
                staggered_row_two {
                  body
                  image {
                    alt
                    url
                  }
                }
              }
            }
          }
        }
      }
    }
    allWordpressWpServices(sort: {fields: menu_order}) {
      edges {
        node {
          title
          slug
          acf {
            service {
              preview_icon
              preview_text
              detail_copy_one
              detail_copy_two
              reset_point
            }
          }
        }
      }
    }
  }
`
